import {
  DEFAULT_GAP_3,
  TABLE_WIDTH,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { View } from "@react-pdf/renderer";

interface PDFTableProps {
  children?: React.ReactNode;
  tableWidth?: string | number;
}

export const PDFTable = ({
  children,
  tableWidth = TABLE_WIDTH,
}: PDFTableProps) => {
  return (
    <View
      style={{
        gap: DEFAULT_GAP_3,
        width: tableWidth,
      }}
    >
      {children}
    </View>
  );
};
